import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";

function ForgotPassword({
    forgotModalClose,
    forgotModal,
    showForgotModal,
    handleLoginClick,
}) {
    const [re] = useState(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
    const [phoneregex] = useState(
        /^\+{0,2}([\-\. ])?(\(?\d{0,3}\))?([\-\. ])?\(?\d{0,3}\)?([\-\. ])?\d{3}([\-\. ])?\d{4}/
    );
    const [err, setErr] = useState(false);

    const [sendOTP, setSendOTP] = useState(false);
    const [otp, setOtp] = useState("");

    const navigate = useNavigate();
    const [isDisable, setDisable] = useState(true);
    const [email, setEmail] = useState("");
    const [patientOTP, setPatientOTP] = useState("");
    const [patientEmail, setPatientEmail] = useState("");

    const [showLoader, setLoader] = useState(false);
    const [seconds, setTimer] = useState(300);
    const [patientcode, setPatientcode] = useState()

    const myRef = useRef(null);
    const [user, setuser] = useState({
        userName: "",
        email: "",
        otp: "",
        password: "",
    });

    // const setSeconds = async (e) => {
    //   forgetpasswordOTP(e);
    // };
    const handleResend = async (e) => {
        forgetpasswordOTP(e);
    };

    const resetFields = () => {
        setErr(false);
        // setSendOTP(false);
        setOtp("");
        // setEmail("");
        setPatientOTP("");
        setPatientEmail("");
        setLoader(false);
        setTimer(500);
    };

    // useEffect(() => {
    //   if (forgotModalClose) {
    //     resetFields();
    //   }
    // }, [forgotModalClose]);

    useEffect(() => {
        if (sendOTP) {
            if (!seconds) return;
            const interval = setInterval(() => {
                const newTime = seconds - 1;
                setTimer(newTime);
            }, 1000);
            return () => {
                clearInterval(interval);
            };
        }
    }, [seconds, sendOTP]);
    const phoneRegex = /^[689]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const handleChange = (val) => {
        setEmail(val);

        if (val === "") {
            setDisable(true);
            setErr(false);
            return;
        }

        if (phoneRegex.test(val)) {
            setDisable(false);
            setErr(true);
        } else if (emailRegex.test(val)) {
            setDisable(false);
            setErr(true);
        } else {
            setDisable(true);
            setErr(false);
        }
    };

    const sendOTPMobile = async (e) => {
        setLoader(true);
        let data;
        if (phoneregex.test(email)) {
            data = {
                mobileNumber: email,
                mobileCheck: 2,
                email: "",
                otp: otp,
            };
        } else {
            data = {
                email: email,
                otp: otp,
                mobileCheck: 2,
                mobileNumber: "",
            };
        }
        e.preventDefault();

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASEURL}PatientOTP/forgetPassValidation?patientOTP=${data.otp}&patientEmail=${data.email}&patientMobileNumber=${data.mobileNumber}`
            );

            let patientCode1 = response.data.split("?patientcode=");
            let patientCode = patientCode1[1];
            console.log(patientCode, "pateienraaaaaaaa");
            setPatientcode(patientCode);
            setLoader(true);
        } catch (error) {
            console.log(err);
            setLoader(false);
            if (error?.message) {
                setErr("Invalid OTP");
                console.log(error);
            }
        }
    };
    if (patientcode) {
        navigate("/forgot-password-reset", {
            state: {
                patientCode: patientcode,
            }
        });
        forgotModalClose();
    }

    const forgetpasswordOTP = async (e) => {
        e.preventDefault();
        if (email.length == 0) {
            setErr("Enter phone number or email");
            return;
        }
        if (phoneregex.test(email)) {
            if (email.length < 10) {
                setErr("Mobile number should be at least 10 digits");
                return;
            }
        }

        let data;
        if (phoneregex.test(email)) {
            data = {
                mobileNumber: email,
                mobileCheck: 2,
                email: "",
            };
        } else {
            data = {
                email: email,
                mobileCheck: 2,
                mobileNumber: "",
            };
        }

        try {
            const token = sessionStorage.getItem("token");
            
            const headers = {
                "Content-Type": "application/json",
            };
    
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            const response = await axios.post(
                `${process.env.REACT_APP_BASEURL}PatientOTP/forgetPassValidation?patientOTP=${data.otp}&patientEmail=${data.email}&patientMobileNumber=${data.mobileNumber}`,
                {
                   
                    headers: headers,
                    
                }
            );

            if (response.data == 1) {
                setSendOTP(true);
                setTimer(300);
            }
        } catch (error) {
            if (error?.message) {
                if (!isNaN(email)) {
                    setSendOTP(false);
                    setErr("This phone number is not registered");
                } else {
                    setSendOTP(false);
                    setErr("This email id is not registered");
                }
            }
        }
    };



    const handleOtpChange = (e) => {
        const re = /^[0-9]*$/;
        const value = e.target.value;

        if (value === "" || re.test(value)) {
            setOtp(value.slice(0, 6)); // Always trim to 6 digits max
        }
    };

    console.log(otp, "defgthjk")



    return (
        <>
            <div className=" px-2">
                <div className="items-center bg-white px-2 py-6">
                    <div className="flex flex-col w-full bg-white sm:px-6">
                        <div className="py-8">
                            {!sendOTP || err === "This email id is not registered" ? (
                                <div className="flex flex-col mb-6">
                                    {/* {email && <span className={`${err ? 'text-brand-lightgreen ' : ''}  font-normal text-xs  tracking-widest`}>{'Enter your Phone Number or Email Address'}</span>} */}
                                    <div className="flex">
                                        <input
                                            type="text"
                                            name="email"
                                            id="sign-in-email-register"
                                            className="w-full h-[50px] rounded-lg bg-white px-5 border outline-none border-gray"
                                            placeholder="Enter Phone number or Registered Email to get OTP"
                                            value={email}
                                            maxLength={60} // Remove conditional maxLength
                                            onChange={(e) => handleChange(e.target.value)}
                                        />
                                    </div>
                                    {err && (
                                        <span className="text-red-600  font-normal text-xs  tracking-widest">
                                            {err}
                                        </span>
                                    )}
                                    <div className="flex w-full mt-6">
                                        <button
                                            onClick={forgetpasswordOTP}
                                            disabled={isDisable}
                                            className={`w-full mt-3 px-4 py-3 rounded-xl font-medium text-base transition-all duration-200
    ${isDisable
                                                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                                    : 'bg-[#004171] hover:bg-[#005999] text-white shadow-md hover:shadow-lg active:scale-95'
                                                }`}
                                        >
                                            Send OTP
                                        </button>

                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <button
                                        onClick={() => { setSendOTP(false); setOtp(""); setErr(false); }}
                                        className="flex items-center gap-1 text-[#004171] text-sm font-medium mb-4 cursor-pointer bg-transparent border-none p-0"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M19 12H5M12 5l-7 7 7 7" />
                                        </svg>
                                        Back
                                    </button>
                                    <div className={"flex flex-col mb-6"}>
                                        <span>{"Enter OTP"}</span>

                                        <div className="flex relative justify-center items-center">


                                            <InputText
                                                name="otp"
                                                id="sign-in-email-password"
                                                onChange={handleOtpChange}
                                                keyfilter="pint"
                                                maxLength={6}
                                                inputMode="numeric"

                                                placeholder="Enter OTP"
                                                className="w-full h-[50px] rounded-lg outline-none bg-white px-5 border border-gray"
                                            />
                                            <span
                                                onClick={(e) => {
                                                    //seconds <= 0 && setSeconds(e);
                                                    seconds <= 0 && handleResend(e);
                                                }}
                                                className={`${seconds == 0
                                                    ? "text-[#004171] cursor-pointer "
                                                    : "text-[#004171] cursor-not-allowed "
                                                    }  font-medium text-sm absolute right-1 mx-2`}
                                            >
                                                {`Resend ${seconds > 0 ? `in ${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}` : ''}`}

                                            </span>
                                        </div>
                                        {err && (
                                            <span
                                                className={`${err === "OTP sent"
                                                    ? "text-green-500 "
                                                    : "text-red-600 "
                                                    }  font-normal text-xs  tracking-widest`}
                                            >
                                                {err}
                                            </span>
                                        )}

                                        <div className="flex w-full mt-8">
                                            <button
                                                onClick={sendOTPMobile}

                                                disabled={otp.length !== 6}
                                                className={`p-3 w-full rounded-lg text-center text-base font-normal ${otp.length !== 6 ? "bg-gray-300 cursor-not-allowed text-gray-700" : "bg-[#004171] text-white"
                                                    }`}
                                            >
                                                Verify OTP
                                                {showLoader && (
                                                    <div className="loader float-right ease-linear text-center rounded-full border-2 border-t-2 border-gray-200 h-5 w-5"></div>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div>
                                <div className="mx-16 my-5 text-center  text-gray-700">
                                    <span className="text-[#004171] text-sm font-normal  ">
                                        {"Already have an account?"}&nbsp;
                                        <p
                                            onClick={handleLoginClick}
                                            className="font-medium text-[#004171] cursor-pointer"
                                        >
                                            {"Login"}
                                        </p>
                                    </span>
                                </div>
                                <div className="text-center text-[#004171] mt-5 font-medium">
                                    {/* <Link
                    to={APP_ROUTES.CONTACTWITHUS}
                    className="text-center text-brand-secondary mt-5 font-medium"
                  >
                    Need Help? Get In Touch
                  </Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;
